<template>
  <ProjectListBody
    :dataSource="dataSource"
    :TabList="TabList"
    :getData="getData"
    :openNoticePage="openNoticePage"
    >
    <template v-slot:default="{ item }">
      <div class="body-title">{{ item.title }}</div>
      <div style="width: 120px; text-align: center;">
        {{ item.publishTime || item.publicStartTime ? moment(item.publishTime || item.publicStartTime).format('YYYY-MM-DD') : '-' }}
      </div>
    </template>
  </ProjectListBody>
</template>

<script>
import moment from 'moment'
import { store } from '@ice/stark-data'
import ProjectListBody from '@/components/ProjectListBody'
import { noticGetPagedWithCf } from '@/api/siteserver'

export default {
	name: "projectList",
  components: { ProjectListBody },
  data() {
    return {
      moment,
      TabList: [
        { label: '正在招标', key: '正在招标' },
        { label: '即将开标', key: '即将开标' },
        { label: '正在候选人公示', key: '候选人公示' }
      ],
      dataSource: []
    }
  },
  methods: {
    async getData(currentTab) {
      const time = moment().format("YYYY-MM-DD HH:mm:ss")
      let filter = ``
      if(currentTab == '正在招标') {
        filter += `s.siteId == ${this.siteId} && s.channelId == 4 && s.checked == true && cf.applyFromTime < "${time}" && cf.applyToTime > "${time}"`
      } else if (currentTab == '即将开标') {
        filter += `s.siteId == ${this.siteId} && s.channelId == 4 && s.checked == true && cf.applyToTime < "${time}" && cf.upPriceFromTime > "${time}"`
      } else {
        filter += `s.siteId == ${this.siteId} && s.channelId == 4 && s.checked == true && cf.upPriceFromTime  < "${time}" && cf.upPriceToTime  > "${time}"`
      }

      const { success, result } = await noticGetPagedWithCf({
        filter: filter,
        order: 's.createdDate desc',
        pageNum: 1,
        pageSize: 10
      })
      if(success) {
        this.dataSource = result.items
      }
    },
    openNoticePage(item) {
			this.$router.push({ path: '/noticeContent', query: { nId: item.id }})
      console.log(item);
      // window.location.href = `${window.urlConfig.sources.mainUrl}/basic/login/`
		},
    goMore(currentTab) {
      store.set('nType', currentTab)
      this.$router.push({ name: 'purchaseInfo' })
    }
  },
  computed: {
    siteId () {
      return window.urlConfig?.web?.siteId
    }
  }
};
</script>

<style lang="less" scoped>
.body-title {
  width: calc(100% - 120px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
